import Vue from 'vue'

require('./components/index.js')

var App = new Vue({
	el : '#app',
	data : function(){
		return {
			showmenu : false
		}
	}
});


// WEBPACK FOOTER //
// ./src/assets/vue/main.js